module.exports = __webpack_public_path__ + "assets/ab9a249f7aac311dd09a2ea8a342fb98.mp3";